module.exports = __webpack_public_path__ + "img/fwlogo@2x.e2827cad.png";